import { classNames } from "../../utils/helpers"
import Box from "../Box"
import Button from "../Button"
import Container from "../Container"
import Heading from "../Heading"
import SectionLink from "../SectionLink"
import SwiperSlider from "../SwiperSlider"
import Text from "../Text"

const SectionRates = ({ section }: any) => {
  const { title, subTitle, listItems } = section
  return (
    <Container constrainedToBreakPoint className="mt-[75px]">
      <Heading as="h1" className="text-blue-500 mb-8 text-center">
        {title}
      </Heading>
      <Text
        variant="large"
        className="text-blue-500 !text-base mb-8 text-center"
      >
        {subTitle}
      </Text>

      <Box className="w-screen lg:w-full">
        <SwiperSlider
          className="px-4 pb-6"
          childClassName="rounded-lg max-w-[75%] lg:max-w-[28vw]"
          slidesPerView="auto"
          spaceBetween={0}
          breakpoints={{
            768: {
              slidesPerView: 3,
            },
            1024: {
              slidesPerView: 4,
            },
          }}
          navigation={false}
        >
          {listItems.map((item: any, idx: any) => (
            <Box className=" lg:max-w-full mb-8" key={idx}>
              <Box className="relative">
                <Box
                  className={classNames(
                    "border-[1.5px] border-gray-300 border-opacity-30 overflow-hidden",
                    idx === 0 && "rounded-tl-[20px] rounded-bl-[20px]",
                    idx === listItems.length - 1 &&
                      "rounded-tr-[20px] rounded-br-[20px]",
                    idx !== listItems.length - 1 && "border-r-0"
                  )}
                >
                  <Box className="py-6 px-5 bg-gray-300 bg-opacity-[0.08] h-[140px] flex flex-col items-center justify-center">
                    <Text
                      variant="large"
                      className="text-blue-500 text-center font-bold"
                    >
                      {item.title}
                    </Text>
                    <Text variant="large" className="text-gray-700 text-center">
                      {item.Label}
                    </Text>
                  </Box>
                  <Box className="py-6 px-5 bg-blue-500">
                    <Heading
                      as="h1"
                      className="text-white text-center font-normal"
                    >
                      {item.value}%
                    </Heading>
                  </Box>
                </Box>
                <Button className="absolute z-10 bottom-[-8px] left-[50%] transform translate-y-1/2 -translate-x-1/2 lg:mt-8 text-white py-2">
                  <SectionLink
                    link={item.linkPrimary}
                    className="bg-orange-500 rounded-xl py-4 px-12"
                  >
                    {item.linkPrimary?.title}
                  </SectionLink>
                </Button>
              </Box>
            </Box>
          ))}
        </SwiperSlider>
      </Box>
    </Container>
  )
}

export default SectionRates
